<style>
    .checked {
        background-color: #dedede;
    }
    .edit-target {
        transition: border 0.35s ease;
        cursor: text;   
        border: solid 1px transparent;
        padding: .5em;
    }
    .edit-target:hover {
        transition: border 0.35s ease;
        border: solid 1px #eee;
    }
    .edit-field {
        width: 100%;
        font-size: .95em;
        padding: .5em;
    }
</style>

<template>
    <div class="d-flex justify-content-between step-row mt-0" :class="{draggable: (!editText && !editNotes && edit)}">
        <div 
            :class="{checked: (completed && !edit)}"
            class="border text-block d-flex justify-content-around align-items-center" 
            style="width: 75%"
        >
            <div style="width: 85%">
                Step {{stepData.order}}<br>
                <div v-show="editText">
                    <textarea 
                        v-model="stepData.text" 
                        v-on:keyup.esc.exact="editText = false"
                        v-on:keyup.alt.enter="editText = false"
                        class="form-control edit-field" 
                        ref="textField"
                    ></textarea>
                    <div class="mt-1">
                        <button type="button" class="btn btn-sm btn-secondary" v-on:click="updateStep()">OK</button>
                        <button type="button" class="btn btn-sm btn-secondary" v-on:click="cancelUpdate()">Cancel</button>
                    </div>
                </div>
                <div v-show="!editText" v-on:click="editStep()" class="edit-target">
                    <span v-if="stepData.text">{{stepData.text}}</span>
                    <span v-else class="text-muted">
                        <span v-show="edit">Click to edit</span>
                    </span>
                </div>
            </div>
            <div v-show="edit" style="width: 85px">
                <button class="btn btn-link" v-on:click="editStep()"><span class="fa fa-pencil-alt"></span></button>
                <button class="btn btn-link" v-on:click="removeStep()"><span class="fa fa-times"></span></button>
            </div>
            <input 
                v-show="!edit" 
                type="checkbox" 
                @input="toggleCompleted"
                :checked="completed"
                class="form-control form-control-lg"
                style="width: 10%"
                :disabled="completedMode"
                v-if="isProgramUser"
            >
        </div>
        <div 
            :class="{checked: (completed && !edit)}"
            class="border text-block" 
            style="width: 22%"
        >
            <div v-show="editNotes">
                <textarea 
                    v-model="stepData.notes" 
                    v-on:keyup.esc.exact="editNotes = false"
                    v-on:keyup.alt.enter="editNotes = false"
                    class="edit-field form-control" 
                    ref="notesField"
                ></textarea>
                <div class="mt-1">
                    <button type="button" class="btn btn-sm btn-secondary" v-on:click="updateStep()">OK</button>
                    <button type="button" class="btn btn-sm btn-secondary" v-on:click="cancelUpdate()">Cancel</button>
                </div>
            </div>
            <div v-show="!editNotes" v-on:click="editStepNotes()" @keyup.enter="editStepNotes()" :class="{'text-muted text-center': !stepData.notes}" class="edit-target" tabindex="0">
                {{ (stepData.notes) ? stepData.notes : notesStandinText}}
            </div>
        </div>        
    </div>
</template>

<script>
    import moment from 'moment'
    import Auth from '../../auth'
    import { nextTick } from 'vue';

    export default {
        components: {},
        props: {
            step: {
                required: true,
                type: Object
            },
            edit: {
                type: Boolean
            },
            completedMode: {
                type:Boolean
            }
        },
        data() {
            return {
                editText: false,
                editNotes: false,
                stepData: {},
                syncing: false,
            }
        },
        computed: {
            notesStandinText: function () {
                if (this.edit) {
                    return 'Click to edit'
                }
                return '--'
            },
            textStandinText: function () {
                if (this.edit) {
                    return 'Click to edit'
                }
                return ''
            },
            isProgramUser: function() {
                return Auth.is('program-user')
            },
            completed: function (){
                return this.stepData.date_completed !== null;
            }
        },
        watch: {
            step: function () {
                this.syncStepData();
            },
            editNotes: function (to, from) {
                (to === false) && this.fireUpdated()
            },
            editText: function (to, from) {
                (to === false) && this.fireUpdated()
            }
        },
        methods: {
            fireUpdated() {
                if (this.dataIsValid()) {
                    this.$emit('update', this.stepData)
                    return;
                }
            },
            dataIsValid() {
                if (!this.stepData.text) {
                    alert('The step cannot be empty. If you want to remove a step click the \'x\' button to the right of the step.');
                    return false;
                }
                return true;
            },
            toggleCompleted() {
                this.stepData.date_completed = (this.stepData.date_completed === null) ? moment().format('YYYY-MM-DD') : null;
                this.fireUpdated()
            },
            editStepNotes() {
                if (this.completedMode || !this.edit) {
                    return;
                }

                this.editNotes = true
                nextTick(() => {
                    this.$refs.notesField.focus()
                })
            },
            editStep() {
                if (this.completedMode || !this.edit) {
                    return;
                }

                this.editText = true
                nextTick(() => {
                    this.$refs.textField.focus()
                })
                this.$emit('modechange')
            },
            updateStep() {
                if (this.dataIsValid() && (this.editText || this.editNotes)) {
                    this.editText = false;
                    this.editNotes = false;
                    this.fireUpdated()
                }
            },
            removeStep() {
                if (confirm("Are you sure you want to delete this step?")) {
                    this.$emit('delete', this.step)
                }
            },
            cancelUpdate() {
                this.editText = false;
                this.editNotes = false;
                this.syncStepData();
            },
            syncStepData() {
                this.syncing = true;
                this.stepData = JSON.parse(JSON.stringify(this.step));
                // this.completed = this.step.date_completed !== null
                this.syncing = false;
            }
        },
        mounted() {
            this.syncStepData();
        }
    
}
</script>